module.exports = __webpack_public_path__ + "img/Sam-kirk-hero.d30f457a.jpg";